// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleAuthor_wrapper__wjRlK","icon":"ArticleAuthor_icon__6cQlb"};